/**
 * The service-order status chip.
 *
 * Renders exactly one of the five customer-facing statuses from the design
 * brief, or the neutral `in_progress` fallback for anything the API sends
 * that this catalogue does not (yet) recognise — never an empty chip.
 *
 * ⚠️ This is the ONLY place `status` drives what a customer sees. It is
 * intentionally not used to describe an item's progress — see the ⛔ note in
 * `api/serviceOrders.ts` for why.
 */
import { useTranslation } from 'react-i18next';
import { statusKey, type ServiceOrderStatus } from '../api/serviceOrders.ts';
import styles from './StatusChip.module.css';

interface Props {
  status: ServiceOrderStatus;
}

export function StatusChip({ status }: Props): React.JSX.Element {
  const { t } = useTranslation();
  const key = statusKey(status);
  return <span className={`${styles['chip']} ${styles[key]}`}>{t(`status.${key}`)}</span>;
}
